export default {
  "successStep": {
    "loadingTitle": "Application Received!",
    "loadingDescription": "Thank you <nameSpan>{{firstName}}</nameSpan>, your application has been received. We're checking our team's availability to assist you...",
    "checkingAvailability": "Checking availability",
    "scheduleHeadingCongrats": "Congratulations, {{firstName}}!",
    "eligibleUpTo": "You're eligible for up to {{amount}}",
    "backToContactOptions": "Back to Contact Options",
    "receivedTitle": "Application Received!",
    "congratsTitle": "Congratulations, {{firstName}}!",
    "thankYouAppointment": "Thank you <nameSpan>{{firstName}}</nameSpan>, we look forward to speaking with you on <timeSpan>{{time}}</timeSpan>",
    "incomingCallFrom": "Incoming call from: {{number}}",
    "scheduleButtonLabel": "Schedule Appointment",
    "missedCallTitle": "Missed our call?",
    "missedCallDescription": "You can reach us at:",
    "scheduleFailedError": "Unable to schedule your call. Please try again or call us directly.",
    "variants": {
      "appointmentScheduled": {
        "title": "Appointment Scheduled",
        "description": "For immediate assistance before your appointment, call:"
      },
      "callInitiated": {
        "title": "Call in Progress",
        "description": "Please answer the incoming call."
      },
      "contactSpecialists": {
        "title": "Contact Our Solution Specialists",
        "description": "Please call us directly or schedule a callback for a convenient time."
      },
      "immediateSchedule": {
        "title": "Schedule Your Consultation",
        "description": "Please schedule a convenient time for us to call you."
      },
      "scheduleCallback": {
        "title": "Schedule a Callback",
        "description": "We have some agents awaiting your call. Please call us directly or schedule a callback."
      },
      "giveUsACall": {
        "title": "Give us a call to discuss your loan application",
        "description": ""
      },
      "weekendContactSpecialists": {
        "title": "Contact Our Solution Specialists",
        "description": "We have some agents awaiting your call. Please call us directly or schedule a callback for a more convenient time."
      },
      "fallbackSchedule": {
        "title": "Schedule Your Consultation",
        "description": "Please schedule a convenient time to discuss your application."
      }
    }
  },
  "unsuccessful": {
    "title": "Identity Verification Required",
    "description": "To protect your security and maintain the integrity of our lending platform, we were unable to verify your identity using the information provided.",
    "cta": "Explore Alternative Options"
  },
  "blocked": {
    "unsuccessfulTitle": "Application Unsuccessful",
    "unsuccessfulDescription": "We were unable to verify your information. You can try again after {{date}}.",
    "checkMoneyLionOffers": "Check MoneyLion Offers",
    "backToContactOptions": "Back to Contact Options",
    "alreadySubmittedTitle": "Application Already Submitted",
    "appointmentScheduled": "Appointment Scheduled",
    "callbackScheduledFor": "Your callback is scheduled for:",
    "immediateAssistance": "For immediate assistance before your appointment:",
    "contactSpecialistsHeading": "Contact Our Loan Specialists",
    "chooseHowToConnect": "Choose how you'd like to connect with us:",
    "scheduleAppointment": "Schedule Appointment",
    "previousDetailsHeading": "Previous Application Details",
    "loanAmountLabel": "Loan Amount",
    "loanPurposeLabel": "Loan Purpose",
    "employmentStatusLabel": "Employment Status",
    "propertyStatusLabel": "Property Status",
    "applyAgainAfter": "You can apply again after <dateSpan>{{date}}</dateSpan>",
    "warningTitle": "Warning!",
    "warningMessage": "Starting a new application before the waiting period expires may result in delays or complications with your existing application. Are you sure you want to proceed?",
    "confirmReset": "Yes, start new application",
    "cancelReset": "Cancel",
    "startNew": "Start new application"
  },
  "scheduleCall": {
    "title": "Schedule a Call",
    "description": "Hi {{firstName}}, our team is currently busy or your calling outside of business hours. Please select a convenient time for us to call you back at {{phoneNumber}}.",
    "loading": "Loading available time slots...",
    "unableToLoad": "Unable to load time slots",
    "loadFailedError": "Failed to load available time slots. Please try again.",
    "refreshFailedError": "Failed to refresh availability. Please try again.",
    "refreshPage": "Refresh page to try again",
    "noSlotsTitle": "No available time slots",
    "noSlotsDescription": "Currently no appointment slots are available. Please try again later or contact us directly.",
    "timesAvailable": "{{available}} of {{total}} times available",
    "backToDates": "Back to dates",
    "changeTime": "Change time",
    "appointmentDetails": "Appointment Details",
    "callbackScheduledFor": "Your callback is scheduled for:",
    "confirm": "Schedule Call",
    "allTimesShownIn": "All times shown in {{tz}} ({{abbr}})"
  }
} as const;
